import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useState } from "react";

import { Select2ApplyBar } from "~/components/select2";
import { UTCDateTimePicker } from "~/components/utc_date_time_picker";

export interface DateRangePopoverProps {
  initialFrom: Date | null;
  initialTo: Date | null;
  onApply: (from: Date | null, to: Date | null) => void;
  onClose: () => void;
}

export function DateRangePopover({
  initialFrom,
  initialTo,
  onApply,
  onClose,
}: DateRangePopoverProps) {
  const [from, setFrom] = useState<Date | null>(initialFrom);
  const [to, setTo] = useState<Date | null>(initialTo);
  const apply = () => {
    onApply(from, to);
    onClose();
  };
  return (
    <Stack>
      <Stack sx={{ minWidth: 280 }} spacing={4}>
        <UTCDateTimePicker
          value={from}
          onChange={(v) => setFrom(v)}
          label="From"
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}
        />
        <UTCDateTimePicker
          value={to}
          onChange={(v) => setTo(v)}
          label="To"
          enableAccessibleFieldDOMStructure={false}
          slots={{ textField: TextField }}
        />
      </Stack>
      <Select2ApplyBar onApply={apply} />
    </Stack>
  );
}
